import { Text, View } from '@react-pdf/renderer';

const Tools = ({ styles, data, headerTitle }: any) => {
	return (
		<View style={styles.mainBox}>
			<Text style={styles.heading}>{headerTitle}</Text>
			<View style={styles.skills}>
				{data?.length > 0 &&
					data?.map((res: any, index: number) => (
						<View key={index} style={styles.skillsBox}>
							<Text style={styles.skillsText}>{res?.title}</Text>
						</View>
					))}
			</View>
		</View>
	);
};

export default Tools;
